
import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { ActivityServiceProxy, DropdownProjectListDto, NumberOfEmployeeDto, OrganizationUnitDto, TeamWorkingStatus, UserListDto } from '@shared/service-proxies/service-proxies';
import { DateTime } from 'luxon';
import { TeamTrackingUserStatusEnum } from '../../models/team-tracking-user-status';

export class TeamTrackingFilters {
    filterSearch: string;
    projectFilterId: number[];
    organizationUnitFilterId: number[];
    memberFilterId: number[];

}

@Component({
    standalone: false,
    selector: "top-stats-and-filters",
    templateUrl: "./top-stats-and-filters.component.html",
    styleUrls: ["./top-stats-and-filters.component.scss"],
    encapsulation: ViewEncapsulation.None,
})
export class TopStatsAndFiltersComponent implements OnInit, AfterViewInit, OnDestroy {
    constructor(private _activitesServiceProxy: ActivityServiceProxy) { }
    employeeCount: NumberOfEmployeeDto;
    selectedDate: Date = new Date();
    @Output() filterValueChanged = new EventEmitter<TeamTrackingFilters>();
    @Output() userStatusSelected = new EventEmitter<TeamTrackingUserStatusEnum>();
    @Output() NewOnTop = new EventEmitter<Boolean>();
    @Output() UserStatusCount = new EventEmitter<NumberOfEmployeeDto>();
    filterObj: TeamTrackingFilters;
    tabIndex: number = 1;
    @Output() MapView = new EventEmitter<boolean>();
    @Output() ListView = new EventEmitter<boolean>();
    @Input() filterHide: boolean;
    @Input() teamWorkingStatus: TeamWorkingStatus
    orgIds: number[];
    proIds: number[];
    useIds: number[];
    isMapView: boolean = false;
    isListView: boolean = true;
    show: boolean;
    maxDay = new Date();
    @Output() gridFilterShow = new EventEmitter<boolean>();
    @Output() gridCalendarShow = new EventEmitter<any>();
    @Output() gridExportShow = new EventEmitter<any>();
    @Input() dataTableValue: number;
    private readonly signalRUserStatusHandler = (data) => this.createcallBackFunctionsforSignalR(data);

    selectedUsersDrpDwn: UserListDto[] = sessionStorage.getItem('activitiesRealTimeTeamTrackingUserFilter')
        ? JSON.parse(sessionStorage.getItem('activitiesRealTimeTeamTrackingUserFilter')) : [];

    selectedProjectsDrpDwn: DropdownProjectListDto[] = sessionStorage.getItem('activitiesRealTimeTeamTrackingProjectFilter')
        ? JSON.parse(sessionStorage.getItem('activitiesRealTimeTeamTrackingProjectFilter')) : [];

    selectedOrgsDrpDwn: OrganizationUnitDto[] = sessionStorage.getItem('activitiesRealTimeTeamTrackingOrgFilter')
        ? JSON.parse(sessionStorage.getItem('activitiesRealTimeTeamTrackingOrgFilter')) : [];

    tenantProductivity: number;
    ngOnInit(): void {
        this.filterObj = new TeamTrackingFilters();
        this.filterObj.memberFilterId = this.selectedUsersDrpDwn.map((r) => r.id);
        this.filterObj.projectFilterId = this.selectedProjectsDrpDwn.map((r) => r.id);
        this.filterObj.organizationUnitFilterId = this.selectedOrgsDrpDwn.map((r) => r.id);

        abp.event.on("SignalRAgentUserStatus", this.signalRUserStatusHandler);

        this.filterValueChanged.emit(this.filterObj);
    }
    ngAfterViewInit(): void {
        this.loadEmployeeStats();
    }

    public createcallBackFunctionsforSignalR(objValues) {
        if (objValues === null) return;
        this.loadEmployeeStats();
    }

    ngOnDestroy(): void {
        abp.event.off("SignalRAgentUserStatus", this.signalRUserStatusHandler);
    }

    loadEmployeeStats() {
        let currDate = new Date();
        this._activitesServiceProxy.getCountNumberOfUserCheckIn(currDate.getTimezoneOffset(), DateTime.fromJSDate(this.setZeroTimeForLocalDate(currDate))).subscribe((employeeCount: NumberOfEmployeeDto) => {
            this.employeeCount = employeeCount;
            this.UserStatusCount.emit(employeeCount)
        });

    }
    setZeroTimeForLocalDate(date: Date): Date {
        date.setHours(0, 0, 0, 0);
        return new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
    }
    filterbyOrg(orgUnits: OrganizationUnitDto[]) {
        orgUnits = orgUnits ?? [];
        this.filterObj.organizationUnitFilterId = orgUnits.map((r) => r.id);
        this.orgIds = orgUnits.map((r) => r.id);
        this.selectedOrgsDrpDwn = orgUnits;
        sessionStorage.setItem('activitiesRealTimeTeamTrackingOrgFilter', JSON.stringify(this.selectedOrgsDrpDwn));
        this.filterValueChanged.emit(this.filterObj);
        this.loadEmployeeStats();
    }

    filterByProject(projectList: DropdownProjectListDto[]) {
        if (Array.isArray(projectList)) {
            projectList = projectList ?? [];
            this.filterObj.projectFilterId = projectList.map((r) => r.id);
            this.proIds = projectList.map((r) => r.id);
            this.selectedProjectsDrpDwn = projectList;
            sessionStorage.setItem('activitiesRealTimeTeamTrackingProjectFilter', JSON.stringify(this.selectedProjectsDrpDwn));
            this.filterValueChanged.emit(this.filterObj);
            this.loadEmployeeStats();
        }

    }

    filterByMember(members: UserListDto[]) {
        if (Array.isArray(members)) {
            members = members ?? [];
            this.filterObj.memberFilterId = members.map((r) => r.id);
            this.useIds = members.map((r) => r.id);
            this.selectedUsersDrpDwn = members;
            sessionStorage.setItem('activitiesRealTimeTeamTrackingUserFilter', JSON.stringify(this.selectedUsersDrpDwn));
            this.filterValueChanged.emit(this.filterObj);
            this.loadEmployeeStats();
        }
    }
    openListForUserStatus(type: TeamTrackingUserStatusEnum) {
        this.userStatusSelected.emit(type);
    }
    newwstOnTop(newest: boolean) {
        this.NewOnTop.emit(newest);
    }
    getTrimmedPercentage(value: number) {
        if (value != undefined) { return value?.toFixed(1); }
    }

    listView() {
        this.isListView = true;
        this.isMapView = false;
        this.filterHide = true;
        this.ListView.emit();
    }

    mapView() {
        this.isListView = false;
        this.isMapView = true;
        this.filterHide = true;
        this.MapView.emit();
    }

    searchbtnShowHide(event) {
        this.show = !this.show;
        this.gridFilterShow.emit(this.show);
    }

    selectViewCalendar(type: string, date?: Date) {
        this.gridCalendarShow.emit({ type: type, date: date });
        // Emit the type and date values
    }

    onExportButtonChangeEvent(event) {
        this.gridExportShow.emit(event);
    }
}

